import { SupportedChainId } from 'constants/chains'

type AddressMap = { [chainId: number]: string }

export const UNIVERSAL_ROUTER_ADDRESS = (chainId: SupportedChainId): string => {
  switch (chainId) {
    case SupportedChainId.ZK_SYNC: // binance smart chain
      return '0x718AeA365b83AFF91e561597ab9D4225f632b52a'
    case SupportedChainId.FANTOM:
      return '0x660FC63608A4641267e958Ee254DC0A275D0eD6e'
    case SupportedChainId.ARBITRUM:
      return '0x3fC91A3afd70395Cd496C647d5a6CC9D4B2b7FAD'
    default:
      throw new Error(`Universal Router not deployed on chain ${chainId}`)
  }
}

export const PERMIT2_ADDRESS = (chainId?: SupportedChainId): string => {
  switch (chainId) {
    case SupportedChainId.ZK_SYNC: // binance smart chain
      return '0x87C0878B54c174199f438470FD74B3F7e1Def295'
    case SupportedChainId.FANTOM:
      return '0x07Ed33a242BD9C08CA3C198e01189e35265024Da'
    case SupportedChainId.ARBITRUM:
      return '0x000000000022d473030f116ddee9f6b43ac78ba3'
    default:
      return '0x87C0878B54c174199f438470FD74B3F7e1Def295'
  }
}

/* V3 Contract Addresses */
export const V3_CORE_FACTORY_ADDRESSES: AddressMap = {
  [SupportedChainId.ZK_SYNC]: '0x31be61CE896e8770B21e7A1CAFA28402Dd701995',
  [SupportedChainId.FANTOM]: '0xaf20f5f19698f1D19351028cd7103B63D30DE7d7',
  [SupportedChainId.ARBITRUM]: '0x1F98431c8aD98523631AE4a59f267346ea31F984',
}

export const MULTICALL_ADDRESS: AddressMap = {
  [SupportedChainId.ZK_SYNC]: '0xFe32D6aA7708863Bf804EE65B489804317A5466c',
  [SupportedChainId.FANTOM]: '0xDb51CffFf3B989d0cB6b58AbF173371b6F2d0D24',
  [SupportedChainId.ARBITRUM]: '0xadF885960B47eA2CD9B55E6DAc6B42b7Cb2806dB',
}

export const ARGENT_WALLET_DETECTOR_ADDRESS: AddressMap = {
  // [SupportedChainId.MAINNET]: '0xeca4B0bDBf7c55E9b7925919d03CbF8Dc82537E8',
}

export const QUOTER_ADDRESSES: AddressMap = {
  [SupportedChainId.ZK_SYNC]: '0x17A172bB5fb2BAf48b6AfD90191cDAaeF8c9A003',
  [SupportedChainId.FANTOM]: '0x45C16C1fFA23662636D4050Eac16eB7AD7cBe29A',
  [SupportedChainId.ARBITRUM]: '0xb27308f9F90D607463bb33eA1BeBb41C27CE5AB6',
}

export const QUOTER_V2_ADDRESSES: AddressMap = {
  [SupportedChainId.ZK_SYNC]: '0x1e034f92e6d071941B58Ca15368adb8b8EBA6AAD',
  [SupportedChainId.FANTOM]: '0x5dB68a533465040F5185e2771746AFed8CC4D14E',
  [SupportedChainId.ARBITRUM]: '0x61fFE014bA17989E743c5F6cB21bF9697530B21e',
}

export const NONFUNGIBLE_POSITION_MANAGER_ADDRESSES: AddressMap = {
  [SupportedChainId.ZK_SYNC]: '0xB2Bd4dB07731BA1517f3f43C4e8fe801F870B374',
  [SupportedChainId.FANTOM]: '0x5973C9E4cC849140cfd1c9dFc75D54D804B5a2fE',
  [SupportedChainId.ARBITRUM]: '0xC36442b4a4522E871399CD717aBDD847Ab11FE88',
}

export const MULTIPOOL_FACTORY: AddressMap = {
  [SupportedChainId.ARBITRUM]: '0x696D71422ea6636e4C7c0af41bDA751D693E6f53',
}

export const MULTIPOOL_DISPATCHER: AddressMap = {
  [SupportedChainId.ARBITRUM]: '0xC9f3Ba958Ff3d22cF35805eD35e9802Cc15Df4bB',
}

export const ENS_REGISTRAR_ADDRESSES: AddressMap = {
  // [SupportedChainId.MAINNET]: '0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e',
}

export const TICK_LENS_ADDRESSES: AddressMap = {
  [SupportedChainId.ZK_SYNC]: '0x09Cbf436DE2273dAC3f0971fB905aCBe41b1CC81',
  [SupportedChainId.FANTOM]: '0x209050d81Aad536Ca2092466B221013B8de7AC6c',
  [SupportedChainId.ARBITRUM]: '0xbfd8137f7d1516D3ea5cA83523914859ec47F573',
}

export const TOKEN_HIDE: { [key: string]: string[] } = {
  [SupportedChainId.ZK_SYNC]: [
    '0xcB86877ef1335469d5C06408f970CB869fb7dC49',
    '0xb32Cb87376ef38bff0f3f751b697a3d89495c36B',
    '0x57e5b67f95632166E9Dc46CEe291aCbDC7ECddEC',
    '0x24B5695Db823674616d603Bd729FD6978f3dd786',
  ],
  [SupportedChainId.FANTOM]: [],
  [SupportedChainId.ARBITRUM]: [],
}

export const POOL_HIDE: { [key: string]: string[] } = {
  [SupportedChainId.ZK_SYNC]: [],
  [SupportedChainId.FANTOM]: [],
  [SupportedChainId.ARBITRUM]: [],
}

export const STRATEGY_HIDE: { [key: string]: string[] } = {
  [SupportedChainId.ZK_SYNC]: [],
  [SupportedChainId.FANTOM]: [],
  [SupportedChainId.ARBITRUM]: [],
}

export const GMI_ADDRESS: AddressMap = {
  [SupportedChainId.ARBITRUM]: '0x6B9Aeb74A2dD2e3488577DC43fb97a7DC2468ab6',
}

export const WAGMI_VESTING: AddressMap = {
  [SupportedChainId.ARBITRUM]: '0xD78A35ed93Da70f4c717EfbAabc52d942F2B90AC',
}

export const WAGMI_ORACLE: AddressMap = {
  [SupportedChainId.ARBITRUM]: '0x2d149685F167b313AcD806AB2E503DC9636c61B5',
}

export const MULTIPOOL_PERIPHERY: AddressMap = {
  [SupportedChainId.ARBITRUM]: '0xC33e12B4e71295Ea5a32E5144EE8cce152832053',
}

export const GMI_PERIPHERY: AddressMap = {
  [SupportedChainId.ARBITRUM]: '0x846E4E8bfb871e07d40c31721486e0C7E36C0ae0',
}
